import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { styled, Pressable, Text } from "dripsy";
var ButtonContainer = styled(Pressable)({
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: 56,
    borderRadius: 8,
    backgroundColor: "#e2e2e2"
});
var Label = styled(Text, {
    defaultVariant: "text.button"
})({
    fontSize: "$button"
});
export function Button(param) {
    var label = param.label, onPress = param.onPress;
    return /*#__PURE__*/ _jsx(ButtonContainer, {
        onPress: onPress,
        children: /*#__PURE__*/ _jsx(Label, {
            children: label
        })
    });
}
